import { getApplicableL2MyTeamModules } from 'Deer/components/navigation/secondary/MyTeam/MyTeamModules';
import { L2_PATHS } from 'Deer/constants/routes';
import { getUserAccess, getUserL1Access, getUserL2Access } from 'Deer/helpers/getUserAccess';
import AllReportsGoals from 'Deer/pages/Team/AllReports/Goals';
import DirectReportsDevelop from 'Deer/pages/Team/DirectReports/Develop';
import DirectReportsGoals from 'Deer/pages/Team/DirectReports/Goals';
import PrivateRoute from 'components/PrivateRoute';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import { Redirect, Route, Switch } from 'react-router-dom';
import { checkVisierAnalyticsEnabled } from 'utils/helpers/featureFlags';

import { PageNotFound404 } from '../PageNotFound404';
import AllReportsDevelop from './AllReports/Develop';
import AllReportsEmployee from './AllReports/Employee';
import AllReportsEngagement from './AllReports/Engagement';
import AllReportsOneOnOne from './AllReports/OneOnOne';
import AllReportsReviews from './AllReports/Reviews';
import { SkipTeamOverview } from './AllReports/SkipTeamOverview';
import { DirectReportsOverview } from './DirectReports/DirectReportsOverview';
import { DirectReportsDisciplinaryActions } from './DirectReports/DisciplinaryActions';
import DirectReportsEmployee from './DirectReports/Employee';
import DirectReportsEngagement from './DirectReports/Engagement';
import DirectReportsOneOnOne from './DirectReports/OneOnOne';
import DirectReportsReviews from './DirectReports/Reviews';
import ViewsGoals from './View/Goals';
import ViewsReviews from './View/Reviews';

const Team = () => {
  const { hasViewsAccess } = getUserL1Access();
  const { isDirectManager, isSkipManager } = getUserAccess();
  const {
    hasGoalAccess,
    hasFeedbackAccess,
    hasOneOnOneAccess,
    hasReviewAccess,
    hasEngagementAccess,
    hasDisciplinaryActionsAccess,
  } = getUserL2Access();
  const { moduleName } = useOrganisationSettings();

  const applicableL2TeamDirectModules = getApplicableL2MyTeamModules('directReports', moduleName);

  const applicableL2TeamAllModules = getApplicableL2MyTeamModules('allReports', moduleName);

  return (
    <Switch>
      {hasGoalAccess
        ? [
            isDirectManager ? (
              <PrivateRoute
                key="directReportsGoals"
                path={L2_PATHS.team.directReports.goal}
                component={DirectReportsGoals}
              />
            ) : null,
            isSkipManager ? (
              <PrivateRoute key="allReportsGoals" path={L2_PATHS.team.allReports.goal} component={AllReportsGoals} />
            ) : null,
          ]
        : null}

      {hasFeedbackAccess
        ? [
            isDirectManager ? (
              <PrivateRoute path={L2_PATHS.team.directReports.develop} component={DirectReportsDevelop} />
            ) : null,
            isSkipManager ? (
              <PrivateRoute path={L2_PATHS.team.allReports.develop} component={AllReportsDevelop} />
            ) : null,
          ]
        : null}

      {hasOneOnOneAccess
        ? [
            isDirectManager ? (
              <PrivateRoute path={L2_PATHS.team.directReports.oneOnOne} component={DirectReportsOneOnOne} />
            ) : null,
            isSkipManager ? (
              <PrivateRoute path={L2_PATHS.team.allReports.oneOnOne} component={AllReportsOneOnOne} />
            ) : null,
          ]
        : null}

      {hasEngagementAccess
        ? [
            isDirectManager ? (
              <PrivateRoute path={L2_PATHS.team.directReports.engagement} component={DirectReportsEngagement} />
            ) : null,
            isSkipManager ? (
              <PrivateRoute path={L2_PATHS.team.allReports.engagement} component={AllReportsEngagement} />
            ) : null,
          ]
        : null}

      {hasReviewAccess
        ? [
            isDirectManager ? (
              <PrivateRoute path={L2_PATHS.team.directReports.review} component={DirectReportsReviews} />
            ) : null,
            isSkipManager ? (
              <PrivateRoute path={L2_PATHS.team.allReports.review} component={AllReportsReviews} />
            ) : null,
          ]
        : null}

      {hasDisciplinaryActionsAccess
        ? [
            isDirectManager ? (
              <PrivateRoute
                path={L2_PATHS.team.directReports.disciplinaryActions}
                component={DirectReportsDisciplinaryActions}
              />
            ) : null,
            isSkipManager ? (
              <PrivateRoute
                path={L2_PATHS.team.allReports.disciplinaryActions}
                component={DirectReportsDisciplinaryActions}
              />
            ) : null,
          ]
        : null}

      <PrivateRoute path={L2_PATHS.team.directReports.employee} component={DirectReportsEmployee} />
      <PrivateRoute path={L2_PATHS.team.allReports.employee} component={AllReportsEmployee} />

      {hasGoalAccess && hasViewsAccess ? <PrivateRoute path={L2_PATHS.team.view.goal} component={ViewsGoals} /> : null}
      {hasReviewAccess && hasViewsAccess ? (
        <PrivateRoute path={L2_PATHS.team.view.review} component={ViewsReviews} />
      ) : null}

      {isDirectManager && checkVisierAnalyticsEnabled() ? (
        <PrivateRoute path={L2_PATHS.team.directReports.overview} component={DirectReportsOverview} />
      ) : null}

      {isSkipManager && checkVisierAnalyticsEnabled() ? (
        <PrivateRoute path={L2_PATHS.team.allReports.overview} component={SkipTeamOverview} />
      ) : null}

      {/* Redirecting partial team reports paths to first applicable L2 path */}
      {applicableL2TeamDirectModules.length > 0 && (
        <PrivateRoute exact path="/app/team/direct-reports">
          <Redirect to={applicableL2TeamDirectModules[0].value} />
        </PrivateRoute>
      )}
      {applicableL2TeamAllModules.length > 0 && (
        <PrivateRoute exact path="/app/team/all-reports">
          <Redirect to={applicableL2TeamAllModules[0].value} />
        </PrivateRoute>
      )}

      <Route path="*" component={PageNotFound404} />
    </Switch>
  );
};

export default Team;
